import gql from 'graphql-tag';

export default gql`
  query CourseLearningNotesConnectedByFirst(
    $pageSize: Int
    $cursor: String
    $sort: TimeSort
    $courseId: String
  ) {
    # 查询列表，不带 courseId 获取全部，默认顺序是 UPDATED_AT_DESC，反向 UPDATED_AT_ASC
    courseLearningNotesConnected(
      pageSize: $pageSize
      cursor: $cursor
      sort: $sort
      courseId: $courseId
    ) {
      hasNext
      endCursor
      list {
        id
        courseId
        noteTitle
        noteContent
        selectValue
        updatedAt
        courseDataConfig {
          name
          description
          cover
        }
      }
      totalCount
    }
  }
`;
